var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "networksGuidelines" }, [
      _c("div", { staticClass: "mb-3" }, [
        _vm._v(
          "Follow these guidelines when editing to ensure formatting is correct:"
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [
            _vm._v(
              "The unique triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” acts jointly as the "
            ),
            _c("strong", [_vm._v("unique ID")]),
            _vm._v(" per network."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "A new unique triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” will "
            ),
            _c("strong", [_vm._v("create")]),
            _vm._v(" a new network."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "An existing triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” will "
            ),
            _c("strong", [_vm._v("update")]),
            _vm._v(" that existing network."),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }